import {AppMode} from '../constants';
import {
  expressSelectedItemsLocalStorage,
  regularSelectedItemsLocalStorage,
  storePickupSelectedItemsLocalStorage
} from './LocalStorage';

export const selectedItemsLocalStorageSelector = (state: any) => {
  switch (state.app.appMode) {
    case AppMode.express:
      return expressSelectedItemsLocalStorage;
    case AppMode.regular:
      return regularSelectedItemsLocalStorage;
    case AppMode.storePickup:
      return storePickupSelectedItemsLocalStorage;
  }
};
